import React, { useEffect, useRef, useState } from 'react'
import {
    I2cIcon,
    I2cTooltip,
    I2cRadioGroup,
    I2cRadioButton,
    I2cPhoneField,
    I2cFileUpload,
    I2cTextarea,
    I2cInput, I2cButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
import { getValidationSchemaCommon, getFieldsCommon } from "./ValidationSchema";
import ContactUsCommon from './CommonBrandingModules/ContactUsCommon';
import FilesUploadService from "../../../Services/FilesUploadService";
import { useMutation } from "react-query";

const CommonBrandingSpecifications = ({
    type,
    setAddFormData,
    addFormData,
    setFormValidStates,
    formDataJson,
    isFetching,
}) => {

    const fields = getFieldsCommon(type);
    const validationSchemaCommon = getValidationSchemaCommon(type);
    const appSelectionForProgram = addFormData[1]?.["1_0"]?.app_selection_for_program || [];
    const fileRefs = useRef({});
    const [fileJson, setFileJson] = useState([]);
    const getFileRef = (fieldName) => {
        if (!fileRefs.current[fieldName]) {
            fileRefs.current[fieldName] = React.createRef();
        }
        return fileRefs.current[fieldName];
    };
    const handleAddAnotherFeature = () => {
        add({
            name: "",
            description: "",
            attachment_file: "",
        });
    };
    // Initialize React Hook Form with Yup resolver
    const methods = useForm({
        resolver: yupResolver(validationSchemaCommon),
        mode: "all",
        reValidateMode: "all",
        shouldUseNativeValidation: false,
        criteriaMode: "all",
        defaultValues: {
            brand_info_common_brand_contact_us_feature_type: "Use i2c Standard Feature",
            brand_info_common_brand_contact_us_i2c_standard_email: "",
            brand_info_common_brand_contact_us_i2c_standard_customer_call_phone: "",
            brand_info_common_brand_contact_us_i2c_standard_customer_call_phone_country: "",
            brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone: "",
            brand_info_common_brand_contact_us_i2c_standard_cardholder_enrollment_phone_country: "",
            brand_info_common_brand_contact_us_i2c_standard_working_hours: "",
            brand_info_common_brand_contact_us_i2c_standard_head_office_address: "",
            brand_info_common_brand_contact_us_i2c_standard_postal_address: "",
            brand_info_common_brand_contact_us_i2c_standard_facebook_link: "",
            brand_info_common_brand_contact_us_i2c_standard_instagram_link: "",
            brand_info_common_brand_contact_us_i2c_standard_twitter_link: "",
            brand_info_common_brand_contact_us_i2c_standard_youtube_link: "",
            brand_info_common_brand_contact_us_i2c_standard_linkedin_link: "",
            brand_info_common_brand_contact_us_custom: [
                {
                    page_name: "",
                    page_link: "",
                },
            ],
            brand_info_common_brand_faqs_type: "Use Customized Content",
            brand_info_common_brand_faqs_content_file: [],
            brand_info_common_brand_faqs_external_link: "",
            brand_info_common_brand_terms_and_condition_type: "Use Customized Content",
            brand_info_common_brand_terms_and_condition_content_file: [],
            brand_info_common_brand_terms_and_condition_content_link: "",
            brand_info_common_brand_privacy_policy_type: "Use Customized Content",
            brand_info_common_brand_privacy_policy_content_file: [],
            brand_info_common_brand_privacy_policy_content_link: "",
            brand_info_common_brand_security_awareness_type: "Use Customized Content",
            brand_info_common_brand_security_awareness_content_file: [],
            brand_info_common_brand_security_awareness_content_link: "",
            brand_info_common_brand_feature: [
                {
                    name: "",
                    description: "",
                    attachment_file: ""
                }
            ],
            brand_info_common_brand_atm_locator: "Yes",
            brand_info_common_brand_atm_locator_content_file: ""
        },
    });

    // Controlls destructuring from the method
    const {
        control,
        formState: { errors },
    } = methods;

    const { fields: fieldFeatureArray, append: add } = useFieldArray({
        control,
        name: "brand_info_common_brand_feature",
    });
  
    
    useEffect(() => {
        if (!isFetching && Object.keys(formDataJson ?? {}).length) {
            if (type === "credit") {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[2]["2_1"][field] ?? "");
                });
                setFileJson(formDataJson[2]["2_1"]);
            }
            else {
                fields.forEach((field) => {
                    methods.setValue(field, formDataJson[3]["3_1"][field] ?? "");
                    setFileJson(formDataJson[3]["3_1"]);
                });
            }
            methods.trigger();
            handleValueChanges();
        }
    }, [isFetching]);

    useEffect(() => {
        customElements.whenDefined('i2c-file-upload').then(() => {
            Object.keys(fileRefs.current).forEach((fieldName) => {
                const fileRef = fileRefs.current[fieldName];
                if (fileRef.current !== null) {
                    const myDropzone = fileRef.current.getDropZone();
                    const token = localStorage.getItem("token");
                    myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
                    myDropzone.options.headers = {
                        'X-Requested-With': null,
                        'Access-Control-Allow-Headers': null,
                        'Authorization': 'Bearer ' + token,
                    };
                }
            });
        });
    }, []);
    // for PDF, svg, ai files
    const handleFileUpload = async (file, fieldName) => {
        const formData = new FormData();
        formData.append("file", file);
        try {
            await fileUpload.mutate({ formData, fieldName });
        } catch (error) {
            console.log(error);
        } finally {
            methods.trigger();
        }
    };

    const fileUpload = useMutation({
        mutationFn: async ({ formData, fieldName }) => { 
            type === "credit" ? setFormValidStates("2_1", false) : setFormValidStates("3_1", false);
            return await FilesUploadService.uploadFile(formData);
        },
        onSuccess: (data, { fieldName }) => {
            if (fieldName === "brand_info_common_brand_faqs_content_file" || fieldName === "brand_info_common_brand_terms_and_condition_content_file" ||
                fieldName === "brand_info_common_brand_privacy_policy_content_file" || fieldName === "brand_info_common_brand_security_awareness_content_file") {
                const currentFiles = methods.getValues(fieldName) || [];
                methods.setValue(fieldName, [...currentFiles, data?.data?.url]);
            }
            else {
                methods.setValue(fieldName, data?.data?.url);
            }

            methods.trigger();
            handleValueChanges();
        },
        onError: (e) => {
            console.log("API error", e);
        },
    });
    // Trigger validation when component mounts
    useEffect(() => {
        methods.trigger();
    }, []);

    const handleValueChanges = () => {
        const values = methods.getValues();
        if (type === "credit") {
            setAddFormData({
                ...addFormData,
                2: {
                    ...addFormData["2"],
                    "2_1": { ...values },
                },
            });
        }
        else {
            setAddFormData({
                ...addFormData,
                3: {
                    ...addFormData["3"],
                    "3_1": { ...values },
                },
            });
        }
    };  
    // Update form validation state when errors change
    useEffect(() => {
        const errorsLength = Object.keys(errors)?.length;
        if (type === "credit") {
            if (errorsLength === 0) setFormValidStates("2_1", true);
            else setFormValidStates("2_1", false);
        }
        else {
            if (errorsLength === 0) setFormValidStates("3_1", true);
            else setFormValidStates("3_1", false);
        }
        // handleValueChanges();
    }, [Object.keys(errors)?.length]);

    return (
        <React.Fragment>
            <div className="forms-instance">
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="custom-label-light">
                            This section must be filled regardless of the i2c platform, such as C-Holder Web, C-Holder Mobile, or both, you want to support.
                        </div>
                    </div>
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Contact Us
                                    <I2cTooltip
                                        content="Cardholders can fill in their queries in a form. They will also find phone numbers for enrollment and customer support. By default, all cardholder inquiries go to i2c's contact center. However, you can provide your contact details if you wish to use your own contact center services."
                                        placement="right-start" >
                                        <I2cIcon label="placement" name="cs-linear-info"></I2cIcon>
                                    </I2cTooltip>
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a" />
                            </span>
                        </div>
                        <div className="custom-label">
                            You can select either the i2c standard contact us feature or use an external URL.
                        </div>
                    </div>
                    <ContactUsCommon
                        control={control}
                        handleValueChanges={handleValueChanges}
                        methods={methods}
                        errors={errors}
                    />
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Frequently Asked Questions
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a" />
                            </span>
                        </div>
                        <div className="custom-label">
                            Cardholders will be able to view Frequently Asked Questions about the services offered by the client.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_common_brand_faqs_type"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        {...field}
                                        name="brand_info_common_brand_faqs_type"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value=== "Use External URL"){
                                                methods.setValue("brand_info_common_brand_faqs_external_link","")
                                            }
                                            else{
                                                methods.setValue("brand_info_common_brand_faqs_content_file",[])
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Use Customized Content", "Use External URL"].map((uFAQ, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_common_brand_faqs_type") === uFAQ
                                                }
                                                value={uFAQ}
                                            >
                                                {uFAQ}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_common_brand_faqs_type &&
                                        methods.formState.touchedFields.brand_info_common_brand_faqs_type
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_common_brand_faqs_type?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {
                        methods.watch("brand_info_common_brand_faqs_type") === "Use Customized Content" ? (
                            <div i2c-grid="12 12@md">
                                <div className="custom-label-light mb-1-5">
                                    Content File(s)
                                </div>
                                <Controller
                                    name="brand_info_common_brand_faqs_content_file"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cFileUpload
                                            ref={getFileRef("brand_info_common_brand_faqs_content_file")}
                                            // max-file-size="0.439453125"
                                            autoProcessQueue={false}
                                            no-mobile-controls
                                            className="customFileUpload"
                                            setAcceptedFiles=".svg, .ai"
                                            icon="linear-document-upload"
                                            label="Click to upload"
                                            caption="or drag and drop"
                                            name="brand_info_common_brand_faqs_content_file"
                                            message="Format must be SVG, AI, PDF or ESP Format."
                                            onI2cFileRemoved={(e) => {
                                                if (
                                                    fileJson?.brand_info_common_brand_faqs_content_file?.length
                                                )
                                                    methods.setValue(
                                                        "brand_info_common_brand_faqs_content_file",
                                                        fileJson?.brand_info_common_brand_faqs_content_file,
                                                    );
                                                else methods.setValue("brand_info_common_brand_faqs_content_file", "");
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                            onI2cAddedFile={(e) => {
                                                const fileRef = getFileRef("brand_info_common_brand_faqs_content_file");
                                                handleFileUpload(
                                                    fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                    "brand_info_common_brand_faqs_content_file"
                                                );
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        ) : <>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_faqs_external_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.i2cinc.com"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_faqs_external_link"}
                                                prefix_label="http://"
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        External Link
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </div>
                {
                    type === "prepaid" && (
                        <>
                            <div i2c-grid="grid gap-md" className="section-space">
                                <div i2c-grid="12">
                                    <div className="sub-heading">
                                        <span className="productIconFlex">
                                            <span slot="label" className="organize-tooltip">
                                                ATM Locator
                                            </span>
                                            <AppSelectionIcons
                                                appSelectionForProgram={appSelectionForProgram}
                                                mobileLink="https://example.com/mobile-app-a"
                                                webLink="https://example.com/web-app-a" />
                                        </span>
                                    </div>
                                </div>
                                <div i2c-grid="12@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            name="brand_info_common_brand_atm_locator"
                                            control={control}
                                            render={({ field }) => (
                                                <I2cRadioGroup
                                                    {...field}
                                                    name="brand_info_common_brand_atm_locator"
                                                    onI2cChange={(e) => {
                                                        field.onChange(e);
                                                        if(e.target.value !== "Yes"){
                                                            methods.setValue("brand_info_common_brand_atm_locator_content_file","")
                                                        } 
                                                        methods.trigger();
                                                        handleValueChanges();
                                                    }}
                                                >
                                                    {["Yes", "No"].map((uFAQ, index) => (
                                                        <I2cRadioButton
                                                            key={index}
                                                            checked={
                                                                methods.watch("brand_info_common_brand_atm_locator") === uFAQ
                                                            }
                                                            value={uFAQ}
                                                        >
                                                            {uFAQ}
                                                        </I2cRadioButton>
                                                    ))}
                                                </I2cRadioGroup>
                                            )}
                                        />
                                        <ErrorMessage
                                            show={
                                                errors.brand_info_common_brand_atm_locator &&
                                                    methods.formState.touchedFields.brand_info_common_brand_atm_locator
                                                    ? true
                                                    : false
                                            }
                                            message={errors.brand_info_common_brand_atm_locator?.message ?? "Invalid input"}
                                        />
                                    </div>
                                </div>
                                {
                                    methods.watch("brand_info_common_brand_atm_locator") === "Yes" && (
                                        <div i2c-grid="12 12@md">
                                            <div className="custom-label-light mb-1-5">
                                                Location Information File(s)
                                            </div>
                                            <Controller
                                                name="brand_info_common_brand_atm_locator_content_file"
                                                control={control}
                                                render={({ field }) => (
                                                    <I2cFileUpload
                                                        ref={getFileRef("brand_info_common_brand_atm_locator_content_file")}
                                                        // max-file-size="0.439453125"
                                                        autoProcessQueue={false}
                                                        no-mobile-controls
                                                        max-files={1}
                                                        className="customFileUpload"
                                                        setAcceptedFiles=".svg, .ai"
                                                        icon="linear-document-upload"
                                                        label="Click to upload"
                                                        caption="or drag and drop"
                                                        name="brand_info_common_brand_atm_locator_content_file"
                                                        message="Format must be SVG, AI, PDF or ESP Format."

                                                        onI2cFileRemoved={(e) => {
                                                            if (
                                                                fileJson?.brand_info_common_brand_atm_locator_content_file?.length
                                                            )
                                                                methods.setValue(
                                                                    "brand_info_common_brand_atm_locator_content_file",
                                                                    fileJson?.brand_info_common_brand_atm_locator_content_file,
                                                                );
                                                            else methods.setValue("brand_info_common_brand_atm_locator_content_file", "");
                                                            methods.trigger();
                                                            handleValueChanges();
                                                        }}
                                                        onI2cAddedFile={(e) => {
                                                            const fileRef = getFileRef("brand_info_common_brand_atm_locator_content_file");
                                                            handleFileUpload(
                                                                fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                                "brand_info_common_brand_atm_locator_content_file"
                                                            );
                                                        }}
                                                    />
                                                )}
                                            />
                                        </div>
                                    )
                                }
                            </div>
                        </>
                    )
                }
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Terms & Conditions
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a" />
                            </span>
                        </div>
                        <div className="custom-label">
                            Cardholders will be able to view the Terms & Conditions of the client.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_common_brand_terms_and_condition_type"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        {...field}
                                        name="brand_info_common_brand_terms_and_condition_type"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value === "Use External URL"){
                                                methods.setValue("brand_info_common_brand_terms_and_condition_content_file",[]                                  )
                                            }
                                            else{
                                                methods.setValue("brand_info_common_brand_terms_and_condition_content_link","")
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Use Customized Content", "Use External URL"].map((uTAC, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_common_brand_terms_and_condition_type") === uTAC
                                                }
                                                value={uTAC}
                                            >
                                                {uTAC}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_common_brand_terms_and_condition_type &&
                                        methods.formState.touchedFields.brand_info_common_brand_terms_and_condition_type
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_common_brand_terms_and_condition_type?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {
                        methods.watch("brand_info_common_brand_terms_and_condition_type") === "Use Customized Content" ? (
                            <div i2c-grid="12 12@md">
                                <div className="custom-label-light mb-1-5">
                                    Content File(s)
                                </div>
                                <Controller
                                    name="brand_info_common_brand_terms_and_condition_content_file"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cFileUpload
                                            ref={getFileRef("brand_info_common_brand_terms_and_condition_content_file")}
                                            // max-file-size="0.439453125"
                                            autoProcessQueue={false}
                                            no-mobile-controls
                                            className="customFileUpload"
                                            setAcceptedFiles=".svg, .ai"
                                            icon="linear-document-upload"
                                            label="Click to upload"
                                            caption="or drag and drop"
                                            name="brand_info_common_brand_terms_and_condition_content_file"
                                            message="Format must be SVG, AI, PDF or ESP Format."
                                            onI2cFileRemoved={(e) => {
                                                if (
                                                    fileJson?.brand_info_common_brand_terms_and_condition_content_file?.length
                                                )
                                                    methods.setValue(
                                                        "brand_info_common_brand_terms_and_condition_content_file",
                                                        fileJson?.brand_info_common_brand_terms_and_condition_content_file,
                                                    );
                                                else methods.setValue("brand_info_common_brand_terms_and_condition_content_file", "");
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                            onI2cAddedFile={(e) => {
                                                const fileRef = getFileRef("brand_info_common_brand_terms_and_condition_content_file");
                                                handleFileUpload(
                                                    fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                    "brand_info_common_brand_terms_and_condition_content_file"
                                                );
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        ) : <>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_terms_and_condition_content_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.i2cinc.com"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_terms_and_condition_content_link"}
                                                prefix_label="http://"
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        External Link
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Privacy Policy
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a" />
                            </span>
                        </div>
                        <div className="custom-label">
                            Cardholders will be able to view the Privacy Policy of the client.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_common_brand_privacy_policy_type"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        {...field}
                                        name="brand_info_common_brand_privacy_policy_type"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value === "Use Customized Content")
                                            {
                                                methods.setValue("brand_info_common_brand_privacy_policy_content_file",[])
                                            }else{
                                                methods.setValue("brand_info_common_brand_privacy_policy_content_link","")
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Use Customized Content", "Use External URL"].map((uPP, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_common_brand_privacy_policy_type") === uPP
                                                }
                                                value={uPP}
                                            >
                                                {uPP}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_common_brand_privacy_policy_type &&
                                        methods.formState.touchedFields.brand_info_common_brand_privacy_policy_type
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_common_brand_privacy_policy_type?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {
                        methods.watch("brand_info_common_brand_privacy_policy_type") === "Use Customized Content" ? (
                            <div i2c-grid="12 12@md">
                                <div className="custom-label-light mb-1-5">
                                    Content File(s)
                                </div>
                                <Controller
                                    name="brand_info_common_brand_privacy_policy_content_file"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cFileUpload
                                            ref={getFileRef("brand_info_common_brand_privacy_policy_content_file")}
                                            // max-file-size="0.439453125"
                                            autoProcessQueue={false}
                                            no-mobile-controls
                                            className="customFileUpload"
                                            setAcceptedFiles=".svg, .ai"
                                            icon="linear-document-upload"
                                            label="Click to upload"
                                            caption="or drag and drop"
                                            name="brand_info_common_brand_privacy_policy_content_file"
                                            message="Format must be SVG, AI, PDF or ESP Format."
                                            onI2cFileRemoved={(e) => {
                                                if (
                                                    fileJson?.brand_info_common_brand_privacy_policy_content_file?.length
                                                )
                                                    methods.setValue(
                                                        "brand_info_common_brand_privacy_policy_content_file",
                                                        fileJson?.brand_info_common_brand_privacy_policy_content_file,
                                                    );
                                                else methods.setValue("brand_info_common_brand_privacy_policy_content_file", "");
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                            onI2cAddedFile={(e) => {
                                                const fileRef = getFileRef("brand_info_common_brand_privacy_policy_content_file");
                                                handleFileUpload(
                                                    fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                    "brand_info_common_brand_privacy_policy_content_file"
                                                );
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        ) : <>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_privacy_policy_content_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.i2cinc.com"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_privacy_policy_content_link"}
                                                prefix_label="http://"
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        External Link
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Security Awareness
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a" />
                            </span>
                        </div>
                        <div className="custom-label">
                            Cardholders will be able to view information related to malicious intent they might
                            be exposed to and their responsibilities to protect devices and personal information from identity theft.
                        </div>
                    </div>
                    <div i2c-grid="12 12@md">
                        <div className="single-field-wrapper">
                            <Controller
                                name="brand_info_common_brand_security_awareness_type"
                                control={control}
                                render={({ field }) => (
                                    <I2cRadioGroup
                                        {...field}
                                        name="brand_info_common_brand_security_awareness_type"
                                        onI2cChange={(e) => {
                                            field.onChange(e);
                                            if(e.target.value === "Use Customized Content")
                                            {
                                                methods.setValue("brand_info_common_brand_security_awareness_content_file",[])
                                            }else{
                                                methods.setValue("brand_info_common_brand_security_awareness_content_link","")
                                            }
                                            methods.trigger();
                                            handleValueChanges();
                                        }}
                                    >
                                        {["Use Customized Content", "Use External URL"].map((uSA, index) => (
                                            <I2cRadioButton
                                                key={index}
                                                checked={
                                                    methods.watch("brand_info_common_brand_security_awareness_type") === uSA
                                                }
                                                value={uSA}
                                            >
                                                {uSA}
                                            </I2cRadioButton>
                                        ))}
                                    </I2cRadioGroup>
                                )}
                            />
                            <ErrorMessage
                                show={
                                    errors.brand_info_common_brand_security_awareness_type &&
                                        methods.formState.touchedFields.brand_info_common_brand_security_awareness_type
                                        ? true
                                        : false
                                }
                                message={errors.brand_info_common_brand_security_awareness_type?.message ?? "Invalid input"}
                            />
                        </div>
                    </div>
                    {
                        methods.watch("brand_info_common_brand_security_awareness_type") === "Use Customized Content" ? (
                            <div i2c-grid="12 12@md">
                                <div className="custom-label-light mb-1-5">
                                    Content File(s)
                                </div>
                                <Controller
                                    name="brand_info_common_brand_security_awareness_content_file"
                                    control={control}
                                    render={({ field }) => (
                                        <I2cFileUpload
                                            ref={getFileRef("brand_info_common_brand_security_awareness_content_file")}
                                            // max-file-size="0.439453125"
                                            autoProcessQueue={false}
                                            no-mobile-controls
                                            className="customFileUpload"
                                            setAcceptedFiles=".svg, .ai"
                                            icon="linear-document-upload"
                                            label="Click to upload"
                                            caption="or drag and drop"
                                            name="brand_info_common_brand_security_awareness_content_file"
                                            message="Format must be SVG, AI, PDF or ESP Format."
                                            onI2cFileRemoved={(e) => {
                                                if (
                                                    fileJson?.brand_info_common_brand_security_awareness_content_file?.length
                                                )
                                                    methods.setValue(
                                                        "brand_info_common_brand_security_awareness_content_file",
                                                        fileJson?.brand_info_common_brand_security_awareness_content_file,
                                                    );
                                                else methods.setValue("brand_info_common_brand_security_awareness_content_file", "");
                                                methods.trigger();
                                                handleValueChanges();
                                            }}
                                            onI2cAddedFile={(e) => {
                                                const fileRef = getFileRef("brand_info_common_brand_security_awareness_content_file");
                                                handleFileUpload(
                                                    fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                    "brand_info_common_brand_security_awareness_content_file"
                                                );
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        ) : <>
                            <div i2c-grid="12 6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="brand_info_common_brand_security_awareness_content_link"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                placeholder="www.i2cinc.com"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"brand_info_common_brand_security_awareness_content_link"}
                                                prefix_label="http://"
                                            >
                                                <span slot="label" className="organize-tooltip">
                                                    <span className="custom-label">
                                                        {" "}
                                                        External Link
                                                    </span>
                                                </span>
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    }
                </div>
                <div i2c-grid="grid gap-md" className="section-space">
                    <div i2c-grid="12 10@md">
                        <div className="sub-heading">
                            <span className="productIconFlex">
                                <span slot="label" className="organize-tooltip">
                                    Additional Feature
                                </span>
                                <AppSelectionIcons
                                    appSelectionForProgram={appSelectionForProgram}
                                    mobileLink="https://example.com/mobile-app-a"
                                    webLink="https://example.com/web-app-a" />
                            </span>
                        </div>
                        <div className="custom-label">
                            If any additional information / features should be displayed on the landing page, please mention here.
                        </div>
                    </div>
                    {
                        fieldFeatureArray.map((field, index) => (
                            <>
                                <div i2c-grid="12 6@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            key={field.id}
                                            name={`brand_info_common_brand_feature[${index}].name`}
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    className="single-input-field"
                                                    placeholder="Enter Feature Name"
                                                    required
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);
                                                        handleValueChanges();
                                                    }}
                                                    size="large"
                                                    name={`brand_info_common_brand_feature[${index}].name`}
                                                >
                                                    <span slot="label" className="organize-tooltip">
                                                        <span className="custom-label">
                                                            {" "}
                                                            Feature Name
                                                            <sup>•</sup>
                                                        </span>
                                                    </span>
                                                </I2cInput>
                                            )}
                                        />
                                    </div>
                                </div>
                                <div i2c-grid="12 6@md">
                                    <div className="single-field-wrapper">
                                        <Controller
                                            key={field.id}
                                            name={`brand_info_common_brand_feature[${index}].description`}
                                            control={control}
                                            render={({ field }) => (
                                                <I2cInput
                                                    {...field}
                                                    className="single-input-field"
                                                    placeholder="Describe the feature"
                                                    onI2cInput={(e) => {
                                                        const value = e.target.value;
                                                        field.onChange(value);
                                                        handleValueChanges();
                                                    }}
                                                    size="large"
                                                    name={`brand_info_common_brand_feature[${index}].description`}
                                                >
                                                    <span slot="label" className="organize-tooltip">
                                                        <span className="custom-label">
                                                            {" "}
                                                            Feature Description
                                                        </span>
                                                    </span>
                                                </I2cInput>
                                            )}
                                        />
                                    </div>
                                </div>
                                <div i2c-grid="12 12@md">
                                    <div className="custom-label-light mb-1-5">
                                        Attachment
                                    </div>
                                    <Controller
                                        key={field.id}
                                        name={`brand_info_common_brand_feature[${index}].attachment_file`}
                                        control={control}
                                        render={({ field }) => (
                                            <I2cFileUpload
                                                ref={getFileRef(`brand_info_common_brand_feature[${index}].attachment_file`)}
                                                // max-file-size="0.439453125"
                                                autoProcessQueue={false}
                                                no-mobile-controls
                                                max-files={1}
                                                className="customFileUpload"
                                                setAcceptedFiles=".svg, .ai"
                                                icon="linear-document-upload"
                                                label="Click to upload"
                                                caption="or drag and drop"
                                                name={`brand_info_common_brand_feature[${index}].attachment_file`}
                                                message="Format must be SVG, AI, PDF or ESP Format."
                                                onI2cFileRemoved={(e) => {
                                                    const fieldName = `brand_info_common_brand_feature[${index}].attachment_file`;
                                                    if (
                                                        fileJson?.[fieldName]?.length
                                                    )
                                                        methods.setValue(
                                                            fieldName,
                                                            fileJson?.[fieldName],
                                                        );
                                                    else methods.setValue(fieldName, "");
                                                    methods.trigger();
                                                    handleValueChanges();
                                                }}
                                                onI2cAddedFile={(e) => {
                                                    const fieldName = `brand_info_common_brand_feature[${index}].attachment_file`;
                                                    const fileRef = getFileRef(fieldName);
                                                    handleFileUpload(
                                                        fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                                        fieldName
                                                    );
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </>
                        ))
                    }

                    <div i2c-grid="12 6@md">
                        <div className="single-field-wrapper">
                            <I2cButton variant="link color"
                                onClick={handleAddAnotherFeature}>
                                <I2cIcon slot="prefix" name="linear-add"></I2cIcon> Add Another
                            </I2cButton>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default CommonBrandingSpecifications
